export const PER_PAGE = 12;
export const PUBLIC_GMW_IP_ADDRESS = '188.200.17.185';

export const SORT_TYPE = {
    SIM_ONLY: 'simonly',
    DEVICE: 'toestel'
}

export const SUBSCRIPTION_TYPE = {
    CONSUMER: 'consumer',
    BUSINESS: 'zakelijk'
}

export const TYPE = {
    NEW: 'nieuw',
    BUSINESS: 'verlengen'
}

export const GENDERS = {
    MALE: {
        value: 'male',
        label: 'De heer'
    },
    FEMALE: {
        value: 'female',
        label: 'Mevrouw'
    }
}

export const CUSTOMER_TYPE = {
    PERSONAL: {
        value: 0,
        label: 'Particulier'
    },
    BUSINESS: {
        value: 1,
        label: 'Zakelijk'
    }
}

export const PROVIDER_NAMES = {
    ODIDO: 'Odido',
    VODAFONE: 'Vodafone',
    KPN: 'KPN',
    BEN: 'Ben',
    LEBARA: 'Lebara',
    HOLLANDSNIEUWE: 'hollandsnieuwe'
}

export const IDENTIFICATION_TYPES = {
    DRIVERS_LICENSE: 'Rijbewijs',
    PASSPORT: 'Paspoort',
    EU_CARD: 'EU-kaart',
    EU_CARD_BOTH_SIDES: 'EU-kaart (voor en achterkant)',
    RESIDENCE_PERMIT: 'Verblijfsvergunning',
    IDIN: 'iDIN',
}

export const NO_INSURANCE_DEVICE_BRANDS = [
    'Apple iPad',
    'Apple Watch',
    'Apple iPad Refurbished',
    'Apple Accessoires',
    'Lenovo Tablet',
    'Samsung Tablet',
    'Samsung Watch',
    'Xiaomi Tablet',
    'abonnement',
]
